import Tablet from "./SVG/tablet.svg?react";

const DevicesIcon = () => {
  return <Tablet />;
};

export default DevicesIcon;
